import Model from "./Model";
import ComponentParameters from "./ComponentParameters";
import AssemblyParameters from "./AssemblyParameters";

export default class Component extends Model {

	constructor(props = {}) {

		super({});

		const parameters = `# Documentation
# https://doc.polymind.app/component/parameters

# Component
component:
    parameters:
        - key: mode
          title: Mode
          type: select
          default: linearPassive
          items:
            - text: Free mode
              value: manual
              icon: mdi-hand
              color: primary
              desc: Do as you wish without any consequence.

            - text: Linear
              value: linear
              icon: mdi-dots-horizontal
              color: primary
              desc: Items are displayed automatically without any consequence.

        - key: speed
          title: Speed
          type: slider
          default: 30
          min: 5
          max: 120

        - key: range
          title: Range
          type: select
          default: 5
          items:
            - text: 3 items
              value: 3
            - text: 5 items
              value: 5
            - text: 10 items
              value: 10

# Dataset
dataset:
    parameters:
        - key: question
          title: Question
          type: column
          mandatory: true
`;

		this.skipFlatParams(['env_variables', 'compiled_parameters']);

		this.setDefaultValues({
			id: null,
			name: '',
			description: '<p></p>',
			has_instructions: false,
			instructions: '<p></p>',
			test_mode: false,
			test_uri: null,
			is_private: false,
			icon: '',
			deployment_url: null,
			repo_url: null,
			repo_branch: null,
			repo_auth_type: 'none',
			repo_user: null,
			repo_ssh_key: null,
			env_variables: [],
			parameters,
			compiled_parameters: {},
		}, props);

		this.compiled_parameters = new ComponentParameters(props.compiled_parameters);
	}

	getDefaultParameters(dataset) {
		const parameters = {};
		const types = ['component', 'dataset'];
		for (let i = 0; i < types.length; i++) {
			const type = types[i];

			if (!parameters[type]) {
				parameters[type] = {};
			}

			this.compiled_parameters[type].parameters.forEach((param, paramIdx) => {
				if (param.default !== undefined) {
					parameters[type][param.key] = param.default;
				}
				if (param.type === 'column' && dataset) {
					const columnIdx = paramIdx % dataset.columns.length;
					parameters[type][param.key] = dataset.columns[columnIdx].guid;
				}
			});
		}
		return new AssemblyParameters(parameters);
	}

	getIcon() {
		return this.icon || 'mdi-cube';
	}

	getColor() {
		return this.color || 'primary';
	}

	getURL() {
		return this.test_mode ? this.test_uri : this.deployment_url;
	}
}
